import { Button, Card, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

function ScanDetailsTable() {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const { selectedDates, selectedHotels, kioskSelection } =
        useContext(SettingContext);
    const [start_date, end_date] = selectedDates;

    const hotel_ids = selectedHotels;
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: `no_scan_count`,
    });
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        calling_hotel_type: kioskSelection,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const {
        status: scanDetailStatus,
        data: scanDetailsRes,
        refetch: fetchScanDetails,
    } = useQuery(
        "scanDetails",
        async () => {
            return await HTTP("/dashboard/getNoScanTableData", { ...formData });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchScanDetails();
    }, []);

    useEffect(() => {
        fetchScanDetails();
    }, [formData]);

    useEffect(() => {
        setFormData({
            ...formData,
            calling_hotel_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        if (scanDetailStatus === "success") {
            const { data: scanData, total } = scanDetailsRes;
            setTotalRecords(total);
            setTableData(scanData);
        }
    }, [scanDetailStatus, scanDetailsRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }
        const updatedFormData = { ...formData, ...others };
        updatedFormData.all_selected =
            updatedFormData.hotel_ids.length > 0 ? false : true;
        updatedFormData.start_date = formatDate(updatedFormData.start_date);
        updatedFormData.end_date = formatDate(updatedFormData.end_date);
        setFormData(updatedFormData);
    }

    const columns = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Transaction ID ",
            dataIndex: "transaction_id",
            key: "transaction_id",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "transaction_id"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Transaction Time ",
            dataIndex: "transaction_time",
            key: "transaction_time",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "transaction_time"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Staff Name",
            dataIndex: "staff_name",
            key: "staff_name",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "staff_name" ? sortedInfo.order : null,
        },
        {
            title: "No of Scan",
            dataIndex: "no_scan_count",
            key: "no_scan_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "no_scan_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Date",
            dataIndex: "call_date_time",
            key: "call_date_time",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "call_date_time"
                    ? sortedInfo.order
                    : null,
        },
    ];

    async function downalodReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getNoScanTableDataReport", {
            ...tempFormData,
        });
        downloadCSV(res, `scan_details_reports`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downalodReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {scanDetailStatus === "loading" ||
                scanDetailStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="transaction_id"
                        className="review-table"
                    />
                )}
            </Card>
        </Card>
    );
}
export { ScanDetailsTable };
